import React from 'react';
import { IconContext } from "react-icons";
import { BsFiles } from "react-icons/bs";

import { Trans } from 'react-i18next';

const FormsCard = ( props ) => {

  return (
    <div className="card forms">
      <div className="data">
        <div className="amount"> { props.amount } </div>
        <div className="tag"> <Trans>Forms Selected</Trans> </div>
      </div>
      <div className="icon">
        <div className="container">
          <IconContext.Provider value={{ size: "20px" }}>
            <div>
              <BsFiles />
            </div>
          </IconContext.Provider>
        </div>
      </div>
    </div>
  )
}

export default FormsCard
